module.exports = __webpack_public_path__ + "img/fps.6668fd5e.jpg";